import React from 'react';
import { makeStyles } from '@material-ui/core';
import Ticker from '../components/Ticker';
import Goal from '../components/Goal';

const useStyles = makeStyles(() => ({
	root: {
		position: 'fixed',
		left: 0,
		top: 0,
		width: '100vw',
		height: '100vh',
		background: '#002',
	},
	goal: {
		height: '20vh',
	},
	ticker: {
		width: '100vw',
		height: '78vh',
		marginTop: '2vh',
	},
}));

export default function Feed() {
	const classes = useStyles();

	return (
		<div className={classes.root}>
			<Goal className={classes.goal} />
			<Ticker className={classes.ticker} asColumn />
		</div>
	);
}
